import './uploadLoading.scss';
import { $document } from '@umu/umu-dom';

const UPLOADE_LOADING_HOST_CLASSNAME = 'photo-uploade-Loading_host';

interface IConfig {
    message: string;
    customWrapperClassName?: string; // 自定义顶层className
}

const UPLOADER_WRAPPER = 'photo-uploade-Loading';
const TEMPLATE = `
<div class="${UPLOADER_WRAPPER}">
    <div class="message">{$0}</div>
    <div class="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
`;

export class UploadLoading {
    public static isShow = true;
    public static show(config: IConfig) {
        if (!UploadLoading.isShow) {
            return UploadLoading;
        }
        let template = TEMPLATE.replace('{$0}', config.message);
        if (config.customWrapperClassName) {
            template = template.replace(UPLOADER_WRAPPER, `${UPLOADER_WRAPPER} ${config.customWrapperClassName}`);
        }

        let el = $document.querySelector(`.${UPLOADE_LOADING_HOST_CLASSNAME}`);
        if (el) {
            el.innerHTML = template;
        } else {
            el = $document.createElement('div');
            el.innerHTML = template;
            el.classList.add(UPLOADE_LOADING_HOST_CLASSNAME);
            $document.body.appendChild(el);
        }
        UploadLoading.isShow = true;
        return UploadLoading;
    }

    public static hide() {
        const el = $document.querySelector(`.${UPLOADE_LOADING_HOST_CLASSNAME}`);
        if (el) {
            $document.body.removeChild(el);
        }
        return UploadLoading;
    }

    public static in(condition: () => boolean) {
        UploadLoading.isShow = condition();
        return UploadLoading;
    }
}
